import { jsx } from 'react/jsx-runtime';

/**
 * IMPORTANT!! Please do not modify this file as it has been auto-generated.
 */
function CheckCircleSolidGlyph(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  return /*#__PURE__*/jsx("svg", {
    viewBox: "0 0 512 512",
    className: className,
    children: /*#__PURE__*/jsx("path", {
      d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
    })
  });
}
CheckCircleSolidGlyph.displayName = 'CheckCircleSolidGlyph';

export { CheckCircleSolidGlyph as default };
